<template>
  <div class="flex flex-row items-center gap-12">
    <div
      class="bg-static-info-mid rounded-sm flex h-40 w-40 shrink-0 items-center justify-center"
      data-test="service-icon"
    >
      <component :is="icon" />
    </div>
    <div>
      <p class="text-static-default-hi body-2-bold">
        {{ title }}
      </p>
      <p v-if="description" class="text-static-default-hi caption">
        {{ description }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Component } from 'vue'

defineProps<{
  title: string
  description?: string
  icon: Component
}>()
</script>
